import { STTProvider } from './STTProvider';
/**
 * A full list of dialects supported by at least one STT provider
 * BCP-47 standards compliant list:
 */
export var LanguageModelDialect;
(function (LanguageModelDialect) {
    LanguageModelDialect["AR_EG"] = "ar-EG";
    LanguageModelDialect["CA_ES"] = "ca-ES";
    LanguageModelDialect["DA_DK"] = "da-DK";
    LanguageModelDialect["DE_DE"] = "de-DE";
    LanguageModelDialect["EN_AU"] = "en-AU";
    LanguageModelDialect["EN_CA"] = "en-CA";
    LanguageModelDialect["EN_GB"] = "en-GB";
    LanguageModelDialect["EN_IN"] = "en-IN";
    LanguageModelDialect["EN_NZ"] = "en-NZ";
    LanguageModelDialect["EN_US"] = "en-US";
    LanguageModelDialect["ES_ES"] = "es-ES";
    LanguageModelDialect["ES_MX"] = "es-MX";
    LanguageModelDialect["ES_AR"] = "es-AR";
    LanguageModelDialect["ES_CL"] = "es-CL";
    LanguageModelDialect["ES_CO"] = "es-CO";
    LanguageModelDialect["ES_PE"] = "es-PE";
    LanguageModelDialect["FI_FI"] = "fi-FI";
    LanguageModelDialect["FR_CA"] = "fr-CA";
    LanguageModelDialect["FR_FR"] = "fr-FR";
    LanguageModelDialect["HI_IN"] = "hi-IN";
    LanguageModelDialect["IT_IT"] = "it-IT";
    LanguageModelDialect["JA_JP"] = "ja-JP";
    LanguageModelDialect["KO_KR"] = "ko-KR";
    LanguageModelDialect["LT_LT"] = "lt-LT";
    LanguageModelDialect["NB_NO"] = "nb-NO";
    LanguageModelDialect["NL_NL"] = "nl-NL";
    LanguageModelDialect["PL_PL"] = "pl-PL";
    LanguageModelDialect["PT_BR"] = "pt-BR";
    LanguageModelDialect["PT_PT"] = "pt-PT";
    LanguageModelDialect["RU_RU"] = "ru-RU";
    LanguageModelDialect["SV_SE"] = "sv-SE";
    LanguageModelDialect["TH_TH"] = "th-TH";
    LanguageModelDialect["ZH_CN"] = "zh-CN";
    LanguageModelDialect["ZH_HK"] = "zh-HK";
    LanguageModelDialect["ZH_TW"] = "zh-TW";
})(LanguageModelDialect || (LanguageModelDialect = {}));
/**
 * This list contains all Telephony and Multimedia language models supported by IBM Watson
 * and their corresponding values
 * @see https://cloud.ibm.com/docs/speech-to-text?topic=speech-to-text-models
 */
const STTDIALECTS_IBM_WATSON = [
    {
        code: LanguageModelDialect.AR_EG,
        value: 'ar-MS_Telephony',
    },
    {
        code: LanguageModelDialect.DE_DE,
        value: 'de-DE_Multimedia',
    },
    {
        code: LanguageModelDialect.EN_AU,
        value: 'en-AU_Multimedia',
    },
    {
        code: LanguageModelDialect.EN_GB,
        value: 'en-GB_Multimedia',
    },
    {
        code: LanguageModelDialect.EN_US,
        value: 'en-US_Multimedia',
    },
    {
        code: LanguageModelDialect.ES_ES,
        value: 'es-ES_Multimedia',
    },
    {
        code: LanguageModelDialect.ES_MX,
        value: 'es-LA_Telephony',
    },
    {
        code: LanguageModelDialect.ES_AR,
        value: 'es-LA_Telephony',
    },
    {
        code: LanguageModelDialect.ES_CL,
        value: 'es-LA_Telephony',
    },
    {
        code: LanguageModelDialect.ES_CO,
        value: 'es-LA_Telephony',
    },
    {
        code: LanguageModelDialect.ES_PE,
        value: 'es-LA_Telephony',
    },
    {
        code: LanguageModelDialect.FR_FR,
        value: 'fr-FR_Multimedia',
    },
    {
        code: LanguageModelDialect.FR_CA,
        value: 'fr-CA_Telephony',
    },
    {
        code: LanguageModelDialect.IT_IT,
        value: 'it-IT_Telephony',
    },
    {
        code: LanguageModelDialect.JA_JP,
        value: 'ja-JP_Multimedia',
    },
    {
        code: LanguageModelDialect.KO_KR,
        value: 'ko-KR_Multimedia',
    },
    {
        code: LanguageModelDialect.NL_NL,
        value: 'nl-NL_Telephony',
    },
    {
        code: LanguageModelDialect.PT_BR,
        value: 'pt-BR_Telephony',
    },
    {
        code: LanguageModelDialect.ZH_CN,
        value: 'zh-CN_Telephony',
    },
];
/**
 * This list contains all dialects supported by Cognitive Speech Services
 * and their corresponding values
 * @see https://docs.microsoft.com/en-us/azure/cognitive-services/speech-service/language-support
 */
const STTDIALECTS_COGNITIVE_SPEECH = [
    {
        code: LanguageModelDialect.AR_EG,
        value: 'ar-EG',
    },
    {
        code: LanguageModelDialect.CA_ES,
        value: 'ca-ES',
    },
    {
        code: LanguageModelDialect.DA_DK,
        value: 'da-DK',
    },
    {
        code: LanguageModelDialect.DE_DE,
        value: 'de-DE',
    },
    {
        code: LanguageModelDialect.EN_AU,
        value: 'en-AU',
    },
    {
        code: LanguageModelDialect.EN_CA,
        value: 'en-CA',
    },
    {
        code: LanguageModelDialect.EN_GB,
        value: 'en-GB',
    },
    {
        code: LanguageModelDialect.EN_IN,
        value: 'en-IN',
    },
    {
        code: LanguageModelDialect.EN_NZ,
        value: 'en-NZ',
    },
    {
        code: LanguageModelDialect.EN_US,
        value: 'en-US',
    },
    {
        code: LanguageModelDialect.ES_ES,
        value: 'es-ES',
    },
    {
        code: LanguageModelDialect.ES_MX,
        value: 'es-MX',
    },
    {
        code: LanguageModelDialect.FI_FI,
        value: 'fi-FI',
    },
    {
        code: LanguageModelDialect.FR_CA,
        value: 'fr-CA',
    },
    {
        code: LanguageModelDialect.FR_FR,
        value: 'fr-FR',
    },
    {
        code: LanguageModelDialect.HI_IN,
        value: 'hi-IN',
    },
    {
        code: LanguageModelDialect.IT_IT,
        value: 'it-IT',
    },
    {
        code: LanguageModelDialect.JA_JP,
        value: 'ja-JP',
    },
    {
        code: LanguageModelDialect.KO_KR,
        value: 'ko-KR',
    },
    {
        code: LanguageModelDialect.LT_LT,
        value: 'lt-LT',
    },
    {
        code: LanguageModelDialect.NB_NO,
        value: 'nb-NO',
    },
    {
        code: LanguageModelDialect.NL_NL,
        value: 'nl-NL',
    },
    {
        code: LanguageModelDialect.PL_PL,
        value: 'pl-PL',
    },
    {
        code: LanguageModelDialect.PT_BR,
        value: 'pt-BR',
    },
    {
        code: LanguageModelDialect.PT_PT,
        value: 'pt-PT',
    },
    {
        code: LanguageModelDialect.RU_RU,
        value: 'ru-RU',
    },
    {
        code: LanguageModelDialect.SV_SE,
        value: 'sv-SE',
    },
    {
        code: LanguageModelDialect.ZH_CN,
        value: 'zh-CN',
    },
    {
        code: LanguageModelDialect.ZH_HK,
        value: 'zh-HK',
    },
    {
        code: LanguageModelDialect.ZH_TW,
        value: 'zh-TW',
    },
    {
        code: LanguageModelDialect.TH_TH,
        value: 'th-TH',
    },
];
/**
 * This list contains a subset of dialects supported by Amazon Transcribe
 * @see https://docs.aws.amazon.com/transcribe/latest/dg/what-is-transcribe.html
 */
const STTDIALECTS_AMAZON_TRANSCRIBE = [
    {
        code: LanguageModelDialect.EN_AU,
        value: 'en-AU',
    },
    {
        code: LanguageModelDialect.EN_GB,
        value: 'en-GB',
    },
    {
        code: LanguageModelDialect.EN_US,
        value: 'en-US',
    },
    {
        code: LanguageModelDialect.ES_ES,
        value: 'es-ES',
    },
    {
        code: LanguageModelDialect.FR_FR,
        value: 'fr-FR',
    },
    {
        code: LanguageModelDialect.HI_IN,
        value: 'hi-IN',
    },
    {
        code: LanguageModelDialect.IT_IT,
        value: 'it-IT',
    },
    {
        code: LanguageModelDialect.JA_JP,
        value: 'ja-JP',
    },
    {
        code: LanguageModelDialect.KO_KR,
        value: 'ko-KR',
    },
    {
        code: LanguageModelDialect.PT_BR,
        value: 'pt-BR',
    },
    {
        code: LanguageModelDialect.RU_RU,
        value: 'ru-RU',
    },
];
/**
 * This list contains a subset of dialects supported by Google Cloud Speech To
 * Text, specifically those with the enhanced video audio type model¹.
 *
 * Google enhanced video model is a language specific "additional"² model, which
 * Google defines as:
 *
 * > Some languages are supported by additional models, optimized for additional
 * > audio types: phone call, enhanced phone call, and enhanced video. These
 * > models can recognize speech captured from these audio sources more accurately
 * > than the default model.
 *
 * 1: This is based on the ST-50 AC "We only use the high quality video STT
 * engine in GCP".
 * 2: "Additional" means in addition to the default model.
 *
 * @see https://fortherecord.atlassian.net/browse/ST-5
 * @see https://cloud.google.com/speech-to-text/docs/languages
 * @see https://cloud.google.com/speech-to-text/docs/enhanced-models
 */
const STTDIALECTS_GOOGLE_CLOUD_SPEECH_TO_TEXT = [
    {
        code: LanguageModelDialect.EN_US,
        value: 'en-US',
    },
    {
        code: LanguageModelDialect.LT_LT,
        value: 'lt-LT',
    },
];
/**
 * Returns a provider-specific value of a given dialect
 * @param sttProvider
 * @param language
 */
export function getProviderSpecificDialect(sttProvider, language) {
    const dialects = getSTTProviderDialects(sttProvider);
    const found = dialects.find(d => d.code === language);
    return found ? found.value : undefined;
}
/**
 * Returns the list of dialects supported by a given provider
 * @param sttProvider
 */
export function getSTTProviderDialects(sttProvider) {
    switch (sttProvider) {
        case STTProvider.IBMWatson:
            return STTDIALECTS_IBM_WATSON;
        case STTProvider.CognitiveSpeech:
            return STTDIALECTS_COGNITIVE_SPEECH;
        case STTProvider.AmazonTranscribe:
            return STTDIALECTS_AMAZON_TRANSCRIBE;
        case STTProvider.GoogleCloudSpeechToText:
            return STTDIALECTS_GOOGLE_CLOUD_SPEECH_TO_TEXT;
        default:
            return [];
    }
}
